<div class="attachments-wrapper">
  <mat-drawer-container class="example-container" hasBackdrop="false" autosize="false">
    <mat-drawer #drawer mode="over" position="end">
      <div class="attachments">
        <div class="drawer-header">
          <h2 class="mat-h2 attachment-heading">Attachments</h2>
          <button mat-icon-button class="close-button" (click)="drawer.toggle()">
            <mat-icon>close</mat-icon>
          </button>
          <div class="clearfix"></div>

        </div>
        <div class="addAttachment">
          <div class="instructions" >
            <b>Instructions:</b>
            <ol>
              <li>
                You cannot upload any file that exceeds 10 MB or the total file size for all attachments cannot exceed
                10 MB.
              </li>
              <li>The permissible file types that can be uploaded are .jpg, .pdf, .png, .txt.</li>
              <li>Remove, if it already exists.</li>
              @if (!account) {
                <li>
                  If the size of attachments file(s) is more than 10 MB, you can always send your additional attachments
                  to
                  <a href="mailto:questions@geothermusa.com">questions&#64;geothermusa.com</a>.
                </li>
              }
            </ol>
          </div>
          <div class="float-right">
            @if (!isSuccess && !projectId) {
              <a
                href="javascript:void(0)"
                class="testing"
                (click)="fileInput.click()"
                >
                <span><img src="/assets/icons/add_red.svg" alt="Add Attachments" />&nbsp;Add Attachment(s)</span>
                <input
                  #fileInput
                  type="file"
                  multiple
                  [accept]="allowedFormat"
                  style="display: none"
                  (change)="getFileDetails($event)" />
                </a>
              }
            </div>
            <div class="clearfix"></div>
            @if (this.selectedFiles.length > 0) {
              <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                <ng-container matColumnDef="fileName">
                  <th mat-header-cell *matHeaderCellDef style="width: 80%">File Name</th>
                  <td mat-cell *matCellDef="let element">
                    <div class="row">
                      <div class="col-1">
                        <img src="/assets/icons/File.svg" style="height: 2rem" alt="File" />
                      </div>
                      <div class="col-11">
                        <span class="testing" style="cursor: auto"> {{ element.name }} </span><br />
                        <span class="mat-subtitle-2">{{ formatSize(element.size) }}</span>
                      </div>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="deleteAttachment">
                  <th mat-header-cell *matHeaderCellDef style="width: 10%"></th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    @if (!isSuccess) {
                      <button mat-icon-button (click)="deleteAttachment(i)">
                        <mat-icon>delete_outline</mat-icon>
                      </button>
                    }
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayAddColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayAddColumns"></tr>
              </table>
            }
            <div class="clearfix"></div>
            @if (projectId && attachedFiles.length > 0) {
              <table
                mat-table
                [dataSource]="dataSourceAttached"
                class="mat-elevation-z8"
                >
                <ng-container matColumnDef="fileName">
                  <th mat-header-cell *matHeaderCellDef style="width: 90%">File Name</th>
                  <td mat-cell *matCellDef="let element">
                    <div class="row">
                      <div class="col-1">
                        <img src="/assets/icons/File.svg" style="vertical-align: baseline; height: 2rem" alt="File" />
                      </div>
                      <div class="col-11">
                        <span class="c-primary"> {{ element.fileName }}</span>
                        <br />
                        <span class="mat-subtitle-2">{{ element.createdAt | date }}</span>
                      </div>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="downloadStoredAttachment">
                  <th mat-header-cell *matHeaderCellDef style="width: 5%"></th>
                  <td mat-cell *matCellDef="let element">
                  </td>
                </ng-container>
                <ng-container matColumnDef="deleteStoredAttachment">
                  <th mat-header-cell *matHeaderCellDef style="width: 10%"></th>
                  <td mat-cell *matCellDef="let element">
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayStoreColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayStoreColumns"></tr>
              </table>
            }
          </div>
        </div>
      </mat-drawer>
      <mat-drawer-content
        [class.drawer-content-yellow]="backgroundClass === 'yellow'"
        [class.drawer-content-gray]="backgroundClass === 'gray'">
        <a href="javascript:void(0)" class="testing c-primary" (click)="drawer.toggle()">
          <img src="/assets/icons/Folder.svg" alt="Folder" style="vertical-align: inherit" /> &nbsp; Add/View
          Attachment(s) [{{ projectId ? attachedFiles.length : selectedFiles.length }}]
        </a>
      </mat-drawer-content>
    </mat-drawer-container>
  </div>
